import { api_endpoint } from "../config";

export default function imgUrl(id, size = 256) {
    if (id) {
        return `${api_endpoint}/media/${id}/file?size=${size}`;
    }
    return null
}